module.exports = __webpack_public_path__ + "static/media/pantaflix.f2361675.png";